@if (apidata$ |async; as apidata) {
  @if (!isMobile) {
    <tabset type="pills">
      <tab heading="{{'common.text_How_to_guide'|cxTranslate}}">
        <app-coreGuidesTab [Guides]="apidata.guideTab"></app-coreGuidesTab>
      </tab>
      <tab heading="{{'common.text_Shipping_Packaging'|cxTranslate}}"><app-coreShippingTab
      [shipping]="apidata.shippingTab"></app-coreShippingTab></tab>
      <tab heading="{{'common.text_Document'|cxTranslate}}">
        <app-coreDocumentsTab [Docs]="apidata.documentTab"></app-coreDocumentsTab>
      </tab>
      <tab heading="{{'common.text_Material_Core_Group'|cxTranslate}}">
        <app-coreMaterialTab></app-coreMaterialTab>
      </tab>
    </tabset>
  }
  @if (isMobile) {
    <accordion [closeOthers]="oneAtATime">
      <accordion-group [isOpen]="isFirstOpen" (isOpenChange)="log($event,1)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading
          type="button">
          <div class="pull-left float-left">{{'common.text_How_to_guide'|cxTranslate}}</div>
          <div class=""><img
            [attr.src]="selectedIndex[1] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'"
          style="width: 20px;" alt=""></div>
        </button>
        <app-coreGuidesTab [Guides]="apidata.guideTab"></app-coreGuidesTab>
      </accordion-group>
      <accordion-group (isOpenChange)="log($event,2)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading
          type="button">
          <div class="pull-left float-left">{{'common.text_Shipping_Packaging'|cxTranslate}}</div>
          <div class=""><img
            [attr.src]="selectedIndex[2] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'"
          style="width: 20px;" alt=""></div>
        </button>
        <app-coreShippingTab [shipping]="apidata.shippingTab"></app-coreShippingTab>
      </accordion-group>
      <accordion-group (isOpenChange)="log($event,3)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading
          type="button">
          <div class="pull-left float-left">{{'common.text_Document'|cxTranslate}}</div>
          <div class=""><img
            [attr.src]="selectedIndex[3] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'"
          style="width: 20px;" alt=""></div>
        </button>
        <app-coreDocumentsTab [Docs]="apidata.documentTab"></app-coreDocumentsTab>
      </accordion-group>
      <accordion-group (isOpenChange)="log($event,4)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading
          type="button">
          <div class="pull-left float-left">{{'common.text_Material_Core_Group'|cxTranslate}}</div>
          <div class=""><img
            [attr.src]="selectedIndex[4] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'"
          style="width: 20px;" alt=""></div>
        </button>
        <app-coreMaterialTab></app-coreMaterialTab>
      </accordion-group>
    </accordion>
  }
}